module.exports = __webpack_public_path__ + "img/zapier-banner-img.64a3fcb2.svg";